import { render, staticRenderFns } from "./follow_button.vue?vue&type=template&id=78c87fe1&scoped=true&"
import script from "./follow_button.vue?vue&type=script&lang=js&"
export * from "./follow_button.vue?vue&type=script&lang=js&"
import style0 from "./follow_button.vue?vue&type=style&index=0&id=78c87fe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c87fe1",
  null
  
)

export default component.exports